import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <section className="flex min-h-[70vh] items-center bg-paper">
            <div className="container-x py-32">
                <p className="eyebrow mb-6">Error 404</p>
                <h1 className="h1-display max-w-3xl">This page is not part of the site.</h1>
                <p className="body-lg mt-6 max-w-lg">
                    The page you are looking for may have been moved or renamed.
                </p>
                <Link to="/" className="btn-primary mt-10" data-testid="notfound-home-link">
                    Back to home
                </Link>
            </div>
        </section>
    );
}
